import React from "react";
import "./styles.scss"
import ESGChatMain from "../esg-chat/esg-chat";

const RealEstateResearchMain = () => {
    return (
        <div className="real-estate-research-main">
            <ESGChatMain
                searchType="RealEstate"
                showDisclosuresSection
            />
        </div>
    )
}

export default RealEstateResearchMain